import React, { useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { startCase } from 'lodash';
import {
  convertedCurrencyFormat,
  dateFormatterForUS,
  longContentFormatter,
  stringOrDashFormatter,
} from '../../../utils/formatHelper';

import styles from './OrderRlrsTable.module.scss';

function getFulfillmentLine(order, variantId) {
  for (const fulfillment of order.fulfillments) {
    const fulfillmentLine = fulfillment.fulfillment_lines.find((fl) => fl.variant_id === variantId);
    if (fulfillmentLine) return fulfillmentLine;
  }
  return null;
}

export function OrderRlrsTable({ order }) {
  const { reverse_logistics_returns: rlrs, currency, conversion_rate, order_exchange_rates } = order || {};
  const rlrRows = useMemo(() => {
    if (!rlrs?.length) return [];

    const rows = [];
    for (const rlr of rlrs) {
      for (const rlrRow of rlr.reverse_logistics_return_lines) {
        const orderLine = order.order_lines.find((ol) => ol.variant_id === rlrRow.variant_id);
        const fulfillmentLine = getFulfillmentLine(order, rlrRow.variant_id);
        const totalValue = convertedCurrencyFormat(
          (fulfillmentLine?.total_line_price || 0) * rlrRow.amount,
          currency,
          conversion_rate,
          order_exchange_rates,
        );

        const reasonType = rlrRow.reason_type || rlr.reason_type;
        const reasonText = rlrRow.reason_text || rlr.reason_text;

        rows.push({
          id: rlrRow.id,
          created_at: rlr.created_at,
          title: orderLine.variant.title,
          sku: orderLine.variant.sku,
          amount: rlrRow.amount,
          total_value: totalValue,
          ra_number: rlr.id_in_source,
          is_open: rlr.was_processed ? 'No' : 'Yes',
          reason_text: rlrRow.reason_text || rlr.reason_text,
          reason_type: reasonType === 'other' ? reasonText : startCase(reasonType),
          tracking_number: rlrRow.tracking_number || rlr.tracking_number,
        });
      }
    }
    return rows;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order]);

  if (!order?.reverse_logistics_returns?.length) {
    return null;
  }

  const columns = [
    {
      text: 'RA Date',
      dataField: 'created_at',
      formatter: dateFormatterForUS,
    },
    {
      text: 'Title',
      dataField: 'title',
    },
    {
      text: 'SKU',
      dataField: 'sku',
    },
    {
      text: 'Quantity',
      dataField: 'amount',
      formatter: stringOrDashFormatter,
    },
    {
      text: 'Total Value',
      dataField: 'total_value',
    },
    {
      text: 'RA Number',
      dataField: 'ra_number',
    },
    {
      text: 'Open',
      dataField: 'is_open',
    },
    {
      text: 'Tracking Number',
      dataField: 'tracking_number',
    },
    {
      text: 'Reason Type',
      dataField: 'reason_type',
      formatter: (cell) => longContentFormatter(cell, 30),
    },
  ];

  return (
    <div className={styles.wrapper}>
      <hr />
      <h3>Return Notifications</h3>

      <div>
        <BootstrapTable data={rlrRows} columns={columns} keyField="id" striped bordered={false} hover />
      </div>
    </div>
  );
}
